import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'

export const AddNewPackage = () => {
  return (
    <div style={{ cursor: 'pointer' }}>
      <Icon
        className="icon-plus-circle-fill"
        style={{ fontSize: 15, color: '#2C73E8' }}
      />
      <Element
        elementName="span"
        style={{
          color: '#2C73E8',
          marginLeft: 5,
        }}
      >
        <Translate value="userManagement.buyPackage.ADD_NEW_PACKAGE" />
      </Element>
    </div>
  )
}
